import React from 'react';

/**
 * Two-column layout: only `.content-area` scrolls; the detail panel stays fixed
 * in the viewport and scrolls inside `.detail-panel-inner`.
 */
export default function ComplianceDashboardShell({ children, panelOpen, panel, overlays = null }) {
  return (
    <div className="compliance-dashboard page">
      <div className="main-layout">
        <div className="content-area">{children}</div>
        <aside
          className={`detail-panel${panelOpen ? ' open' : ''}`}
          aria-hidden={!panelOpen}
        >
          {panelOpen ? panel : null}
        </aside>
      </div>
      {overlays}
    </div>
  );
}
